<template>
  <vz-autocomplete
    :modelValue="modelValue"
    placeholder="Выберите проект"
    value-template="{name}"
    title-template="{name}"
    description-template="{contractor.name} ИНН:{contractor.inn} КПП:{contractor.kpp}"
    value-key="guid"
    :items="filterItems"
    @search="search"
    v-bind="$attrs"
  />
</template>

<script setup lang="ts">
import VzAutocomplete from '~/components/ui-kit/vz-autocomplete.vue'
import {useOrderProjects} from "~/stores/personal/order-projects";

// Условно наследуем компонент от VzAutocomplete
defineOptions({
  inheritAttrs: false
})

const emit = defineEmits(['changeGuidContractor'])

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  }
})

const {projectsList} = useOrderProjects();

const s = ref('')

const filterItems = computed(() => {
  if (s.value) {
    const sLower = s.value.toLowerCase();
    return projectsList.filter((project) => {
      return project.name.toLowerCase().includes(sLower) ||
        project.contractor.inn.includes(sLower) ||
        project.contractor.kpp.includes(sLower) ||
        project.contractor.name.toLowerCase().includes(sLower)
    })
  }
  return projectsList
})

function search(val: string) {
  s.value = val
}

watch(() => props.modelValue,
  () => {
    const findProject = projectsList.find((project) => project.guid === props.modelValue)
    if (!findProject) {
      return;
    }
    emit('changeGuidContractor', findProject.contractor.guid)
  }
)
</script>
